import React from 'react';
import {
    Tag,
    Row,
    Space,
    Button,
    Input,
    DatePicker,
    Select,
    Table,
    Pagination,
    Checkbox,
    Modal,
    Transfer,
    message,
    Divider,
    Rate,
    Popover,
    Image,
} from 'antd';
import { Redirect, Link, withRouter } from 'react-router-dom';
import store from "../store/store.js";
import { CloseOutlined } from '@ant-design/icons'
import moment from 'moment';
import Genjin from '../public/genjin.js';

const { Search } = Input;
const { Option } = Select;
const { RangePicker } = DatePicker;
const { TextArea } = Input;

class DwView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            condition: {},
            visible: false,
        };
        this.mingpian = React.createRef();
        this.genjin = React.createRef();
        store.subscribe(() => {
            // console.log('state状态改变了，新状态如下')
            // console.log(store.getState().data.isLogin)
        })
    }

    componentDidMount() {


    }

    mdchange() {
        let that = this
        let visible = !that.state.visible
        that.setState({
            visible
        })
        if (visible) {
            that.getdata()
        } else {
            that.setState({
                condition: {},
            })
        }
    }

    getdata() {
        let that = this
        let arr = {}
        arr.id = that.props.id
        arr.type = 2
        fetch('/Zaiti/detail', {
            method: "POST",
            body: JSON.stringify(arr)
        })
            .then(res => res.json())
            .then(data => {
                data.condition = data.data ? data.data : {}
                that.setState({
                    ...data
                })
            })
    }

    arrfjlist(arr) {
        if (arr) {
            return arr.map((item, index) =>
                <div key={index}>
                    <a href={item.url} download={item.name}>
                        {item.name}
                    </a>
                </div>
            )
        }
    }

    arrRych(arr) {
        if (arr) {
            return arr.map((item, index) =>
                <Tag color={'blue'}>{item}</Tag>
            )
        }
    }
    arrPiclist(arr) {
        if (arr) {
            return arr.map((item, index) =>
                <Image key={index} src={item.url} width={100} height={100} />
            )
        }
    }

    render() {

        return (
            <>
                {this.props.title ?
                    <a href='javascript:void(0)' type="link" onClick={this.mdchange.bind(this)}>{this.props.title}</a> :
                    <a href='javascript:void(0)' type="link" onClick={this.mdchange.bind(this)}>查看</a>}

                <Modal title="查看详情" destroyOnClose={true} bodyStyle={{ padding: 15 }} width={1200}
                    visible={this.state.visible} onCancel={this.mdchange.bind(this)} footer={null}>
                    <div className={'view_box'}>
                        <div className={'view_title'}>载体信息</div>
                        <div className={'view_info view_info2'}>
                            <div className={'item'}>
                                <div className={'p1'}>写字楼名称</div>
                                <div className={'p2'}>{this.state.condition.name}</div>
                            </div>
                            <div className={'item'}>
                                <div className={'p1'}>地址</div>
                                <div className={'p2'}>{this.state.condition.address}</div>
                            </div>
                            <div className={'item'}>
                                <div className={'p1'}>总占地面积</div>
                                <div className={'p2'}>{this.state.condition.zzdmj}</div>
                            </div>
                            <div className={'item'}>
                                <div className={'p1'}>总建筑面积</div>
                                <div className={'p2'}>{this.state.condition.zjzmj}</div>
                            </div>
                            <div className={'item'}>
                                <div className={'p1'}>出房率</div>
                                <div className={'p2'}>{this.state.condition.cfl}</div>
                            </div>
                            <div className={'item'}>
                                <div className={'p1'}>租售意向</div>
                                <div className={'p2'}>{this.state.condition.zsyx_text}</div>
                            </div>
                            <div className={'item'}>
                                <div className={'p1'}>租售面积</div>
                                <div className={'p2'}>{this.state.condition.zsmj}</div>
                            </div>
                            <div className={'item'}>
                                <div className={'p1'}>层数</div>
                                <div className={'p2'}>{this.state.condition.cs}</div>
                            </div>
                            <div className={'item'}>
                                <div className={'p1'}>层高</div>
                                <div className={'p2'}>{this.state.condition.cg}</div>
                            </div>
                            <div className={'item'}>
                                <div className={'p1'}>净高（梁下高度）</div>
                                <div className={'p2'}>{this.state.condition.jg}</div>
                            </div>
                            <div className={'item'}>
                                <div className={'p1'}>地面承压</div>
                                <div className={'p2'}>{this.state.condition.dmcy}</div>
                            </div>
                            <div className={'item'}>
                                <div className={'p1'}>配电</div>
                                <div className={'p2'}>{this.state.condition.pd}</div>
                            </div>
                            <div className={'item'}>
                                <div className={'p1'}>商务配套</div>
                                <div className={'p2'}>{this.state.condition.swpt}</div>
                            </div>
                            <div className={'item'}>
                                <div className={'p1'}>消防等级</div>
                                <div className={'p2'}>{this.state.condition.xfdj}</div>
                            </div>
                            <div className={'item'}>
                                <div className={'p1'}>交房标准</div>
                                <div className={'p2'}>{this.state.condition.jfbz}</div>
                            </div>
                            <div className={'item'}>
                                <div className={'p1'}>房地产权证</div>
                                <div className={'p2'}>{this.state.condition.fdcqz}</div>
                            </div>
                            <div className={'item'}>
                                <div className={'p1'}>停车位</div>
                                <div className={'p2'}>{this.state.condition.tcw}</div>
                            </div>
                            <div className={'item'}></div>
                            <div className={'item'}>
                                <div className={'p1'}>出售价格</div>
                                <div className={'p2'}>{this.state.condition.csjg}</div>
                            </div>
                            <div className={'item'}>
                                <div className={'p1'}>租赁价格</div>
                                <div className={'p2'}>{this.state.condition.zljg}</div>
                            </div>
                            <div className={'item'}>
                                <div className={'p1'}>物业费</div>
                                <div className={'p2'}>{this.state.condition.wyf}</div>
                            </div>
                            <div className={'item'}>
                                <div className={'p1'}>能源费</div>
                                <div className={'p2'}>{this.state.condition.nyf}</div>
                            </div>
                            <div className={'item'}>
                                <div className={'p1'}>是否有中介费</div>
                                <div className={'p2'}>{this.state.condition.sfyzjf_text}</div>
                            </div>
                            <div className={'item'}>
                                <div className={'p1'}>中介费标准</div>
                                <div className={'p2'}>{this.state.condition.zjfbz}</div>
                            </div>
                            <div className={'item'}>
                                <div className={'p1'}>是否溢价</div>
                                <div className={'p2'}>{this.state.condition.sfyyj_text}</div>
                            </div>
                            <div className={'item'}>
                                <div className={'p1'}>溢价</div>
                                <div className={'p2'}>{this.state.condition.yj}</div>
                            </div>
                            <div className={'item'}>
                                <div className={'p1'}>信息负责人</div>
                                <div className={'p2'}>{this.state.condition.xxfzr}</div>
                            </div>
                            <div className={'item'}>
                                <div className={'p1'}>状态</div>
                                <div className={'p2'}>{this.state.condition.status_text}</div>
                            </div>
                            <div className={'item all'}>
                                <div className={'p1'}>备注</div>
                                <div className={'p2'}>
                                    <div
                                        dangerouslySetInnerHTML={{ __html: this.state.condition.bz }}></div>
                                </div>
                            </div>
                            {this.state.condition.imglist && this.state.condition.imglist.length ? <>
                                <div className={'item all'}>
                                    <div className={'p1'}>图片</div>
                                    <div className={'p2'}>
                                        <Image.PreviewGroup
                                            preview={{
                                                onChange: (current, prev) => console.log(`current index: ${current}, prev index: ${prev}`),
                                            }}
                                        >
                                            <Space wrap>
                                                {this.arrPiclist(this.state.condition.imglist)}
                                            </Space>
                                        </Image.PreviewGroup>
                                    </div>
                                </div>
                            </> : null}
                        </div>
                    </div>
                </Modal>
            </>
        )
    }
}

export default DwView
